import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import {
  Box, Drawer, Typography, Avatar,
} from '@mui/material';
// mock
import Cookies from 'js-cookie';
import UserLogoutMenu from '../../sections/@dashboard/user/UserLogoutMore';
import { usePrivilege } from '../../PrivilegeContext';
import account from '../../_mocks_/account';
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
// import Logo from '../../components/Logo';
import Scrollbar from '../../components/Scrollbar';
import NavSection from '../../components/NavSection';
//
import navConfig from './NavConfig';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    width: DRAWER_WIDTH,
  },
}));

const AccountStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
}));

// ----------------------------------------------------------------------
export default function DashboardSidebar({
  isOpenSidebar, onCloseSidebar, mainName, roleName,
}) {
  const { pathname } = useLocation();
  const isDesktop = useResponsive('up', 'lg');

  const { role, modules } = usePrivilege();

  // Get operator name from cookie
  const operatorName = Cookies.get('selectedOperatorName');

  // Fallback to role name if operator name is not available
  let displayText = operatorName;
  if (!displayText) {
    let displayRoleName = roleName;
    if (roleName === '101') {
      displayRoleName = 'Super Admin';
    } else if (roleName === '102') {
      displayRoleName = 'Operator Admin';
    } else if (roleName === '111') {
      displayRoleName = 'Editor';
    } else if (roleName === '110') {
      displayRoleName = 'Viewer';
    }
    displayText = displayRoleName;
  }

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
  }, [isOpenSidebar, onCloseSidebar, pathname]);

  // filters the nav links based on users role
  const filteredNavConfig = navConfig.filter((item) => {
    console.log(`[Sidebar Filter] Checking item: ${item.title}`, {
      item,
      role,
      modules,
    });

    const isRoleAllowed = item.restrictedToRole?.includes(role);
    console.log(`[Sidebar Filter] ${item.title} - restrictedToRole:`, item.restrictedToRole, 'isRoleAllowed:', isRoleAllowed); //
    if (item.restrictedToRole) {
      console.log(`[Sidebar Filter] ${item.title} - Using restrictedToRole check, returning:`, isRoleAllowed);
      return isRoleAllowed;
    }

    const moduleEntry = modules?.[item.module];
    const permissionKey = moduleEntry && typeof moduleEntry === 'object'
      ? Object.keys(moduleEntry)[0]
      : null;

    if (moduleEntry && permissionKey) {
      return moduleEntry[permissionKey] === true;
    }

    const isSuperAdmin = role === 900 || role === 101;
    console.log(`[Sidebar Filter] ${item.title} - Fallback to super admin check, returning:`, isSuperAdmin);
    return isSuperAdmin;
  });

  console.log('[Sidebar Filter] Final filteredNavConfig:', filteredNavConfig.map((item) => item.title));

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >

      <Box sx={{
        mt: 6, mb: 5, ml: 5, px: 5,
      }}
      >
        <img width={110} src="https://storage.googleapis.com/asiamobiliti-static-assets/trek_logomark.png" alt="Trek Logo" />
        <img src="/static/icons/asiaMobiliti.png" alt="asiaMobiliti" />
      </Box>

      <NavSection navConfig={filteredNavConfig} />

      <Box sx={{ flexGrow: 1 }} />

      <Box sx={{
        mb: 4, mx: 2.5, borderTop: '2px solid', pt: 2, borderColor: 'grey.300',
      }}
      >
        <Box>
          <AccountStyle>
            <Avatar src={account.photoURL} alt="photoURL" />
            <Box sx={{
              ml: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%',
            }}
            >
              <Box>
                <Typography variant="body2" sx={{ color: 'text.primary', fontWeight: 'fontWeightMedium' }}>
                  {mainName}
                </Typography>
                {displayText && displayText !== 'undefined' && (
                  <Typography variant="body2" sx={{ color: 'grey.600' }}>
                    {displayText}
                  </Typography>
                )}
              </Box>
              <UserLogoutMenu />
              {' '}
              {/* New Component */}
            </Box>
          </AccountStyle>
        </Box>
      </Box>

    </Scrollbar>
  );
  return (
    <RootStyle>
      {!isDesktop && (
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{
            sx: { width: DRAWER_WIDTH },
          }}
        >
          {renderContent}
        </Drawer>
      )}

      {isDesktop && (
        <Drawer
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: DRAWER_WIDTH,
              bgcolor: 'background.default',
              borderRightStyle: 'solid',
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </RootStyle>
  );
}

DashboardSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
  mainName: PropTypes.string,
  roleName: PropTypes.string,
};

DashboardSidebar.defaultProps = {
  isOpenSidebar: false,
  onCloseSidebar: undefined,
  mainName: '',
  roleName: '',
};
